<template>
  <div class="p-0 m-0 no-gutters" v-if="tuesdays.length">
    <ul
      class="list-group list-group-flush mt-0 p-0 ml-4 mr-1"
      style="padding-top: 0rem !important"
    >
      <li class="list-group-item">
        <!-- <b class="ml-0 badge-light mr-1">Please Note: </b>--> 
        All weekly order requests MUST be entered into the system by <b>11:59 pm on Tuesday</b> of 
        each week. We are unable to process or fulfill orders placed after the
        deadline.
      </li>
      <li class="list-group-item">
        If quantities of more than 350 doses are required for a week, contact the DPEBB by e-mailing         
        <b>dpebimmunizations@health.gov.sk.ca.</b> The e-mail must be received by <b class="text-danger">12:00 noon on Tuesday.</b>
      </li>
    </ul>
   <div class="alert alert-info ml-4 mr-1 mb-1" role="alert">
      <!-- <b class="ml-0 mr-1">Please Note: </b> -->
       All orders need to be  placed using the number of doses. We are unable to process or fulfill
        orders for quantities that are not exact multiples of the minimum listed
        below.<br>
      • For Pfizer, the minimum quantity is <b>30 doses</b>, and can only be
      allocated in multiples of 30. <br />
      • For Moderna, the minimum quantity is <b>140 doses</b>, and can only be
      allocated in multiples of 140.<br />
      • For Pediatric Pfizer, the minimum quantity <b>50 doses</b>, and can only be
      allocated in multiples of 50.
    </div>
  <div class="alert warningbg ml-4 mr-1 mb-1" role="alert">
      <!-- <b class="ml-0 mr-1">Please Note: </b><br> -->
       • Requests for the vaccine should be made a minimum of two weeks in advance. <b>YOU WILL STILL BE REQUIRED TO LOG IN WEEKLY AND CLICK SUBMIT FOR YOUR REQUEST TO BE FLAGGED FOR DPEBB.</b><br> 
       • If your pharmacy does not want any vaccine for that particular week, please enter 0 and submit.<br>
       • <b>The quantity requested may not be the quantity your pharmacy actually receives, based on
          available vaccine supply.</b> Please do not book appointments until the quantity being shipped to your pharmacy is confirmed. You can check what is being shipped to you by clicking on the Vaccine Allocation option in the left menu.
    </div>


    <div class="container-fluid">
      <div class="row pl-4 align-items-center">
        <div
          class="col-6 text-left align-items-center card-header border border-primary alert-info"
          style="height: 2rem; padding-top: 0.3rem"
        >
          <strong>Coming Two Weeks Requests</strong>
        </div>
        <div
          class="col-6 text-center align-items-center card-header border border-info"
          style="height: 2rem; padding-top: 0.3rem"
        >
          <strong>Next Two Weeks Forecast</strong>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row align-items-left pl-4 no-gutter">
        <div class="col-sm-3 text-left card">
          <div class="row no-gutter pr-5 mt-2">
            <div class="col-6">Request for Week of:</div>
            <div class="col-6">
                <span >{{DisplayWeek1}}</span>
              <span class="" type="text" v-show="false">
                <datepicker
                  :disabled="disdates"
                  :open-date="new Date()"
                  :disabledDates="{
                    days: [0, 1, 3, 4, 5, 6],
                    to: new Date(Date.now() - 8640000),
                  }"
                  v-model="Week1"
                  :format="dateFormat"
                  id="ReqDate1"
                  :bootstrap-styling="true"
                  :input-class="datapickClass"
                  name="ReqDate1"
                ></datepicker>
              </span>
            </div>
             
          </div>
          <v-client-table class="mb-0"
            :columns="columns"
            v-model="Week1Products"
            :options="options"
            :disabled="disWeek1"
          >
        
            <div
              v-for="column in options.editableColumns"
              :key="column"
              :slot="column"
              slot-scope="{ row, update }"> 

          <div> 
              <input
                type="number"
                min="1"
                max="350"
                v-model="row[column]"
                @input="update"
                :disabled="disWeek1"
              />
          </div>
          <!--
          <div v-if="row.id=='5'">          
          <select id="override"    v-bind:value="row.id"   @input="update"  v-model="row[column]"   class="form-control form-control-sm select-css" >  
            <option v-for="option in prod5qty" v-bind:value="option.id"  :key="option.id">            
            <strong>{{option.text}} </strong>
            </option>
          </select>
          </div>
          <div v-if="row.id=='2'">          
          <select id="override"    v-bind:value="row.id"   @input="update"  v-model="row[column]"   class="form-control form-control-sm select-css" >  
            <option v-for="option in prod2qty" v-bind:value="option.id"  :key="option.id">            
            <strong>{{option.text}} </strong>
            </option>
          </select>
          </div>
         <div v-if="row.id=='3'">          
          <select id="override"    v-bind:value="row.id"   @input="update"  v-model="row[column]"   class="form-control form-control-sm select-css" >  
            <option v-for="option in prod3qty" v-bind:value="option.id"  :key="option.id">            
            <strong>{{option.text}} </strong>
            </option>
          </select>
          </div>
         <div v-if="row.id=='4'">          
          <select id="override"    v-bind:value="row.id"   @input="update"  v-model="row[column]"   class="form-control form-control-sm select-css" >  
            <option v-for="option in prod4qty" v-bind:value="option.id"  :key="option.id">            
            <strong>{{option.text}} </strong>
            </option>
          </select>
          </div>
         <div v-if="row.id=='1'">          
          <select id="override"    v-bind:value="row.id"   @input="update"  v-model="row[column]"   class="form-control form-control-sm select-css" >  
            <option v-for="option in prod1qty" v-bind:value="option.id"  :key="option.id">            
            <strong>{{option.text}} </strong>
            </option>
          </select>         
          </div>
          -->

        </div>            
        </v-client-table>
        </div>
        <div class="col-sm-3 text-left card">
          <!-- <div
            class="row text-center no-gutter mr-0 card-header border border-primary alert-info"
            style="
              height: 2rem;
              padding-top: 0.3rem;
              text-align: center !important;
            "
          >
            <strong>Week: 2 </strong>
            <strong class="ml-3"> Available Vaccines</strong>
          </div> -->
          <div class="row no-gutter pr-5 mt-2">
            <div class="col-6">Request for Week of:</div>

            <div class="col-6">
               <span >{{DisplayWeek2}}</span>
              <span class="" type="text" v-show="false">
                <datepicker
                  :disabled="disdates"
                  :open-date="new Date()"
                  :disabledDates="{
                    days: [0, 1, 3, 4, 5, 6],
                    to: new Date(Date.now() - 8640000),
                  }"
                  v-model="Week2"
                  :format="dateFormat"
                  id="ReqDate2"
                  :bootstrap-styling="true"
                  :input-class="datapickClass"
                  name="ReqDate2"
                ></datepicker>
              </span>
            </div>
            
          </div>
          <v-client-table class="mb-0"
            :columns="columns"
            v-model="Week2Products"
            :options="options"
          >
            <div
              v-for="column in options.editableColumns"
              :key="column"
              :slot="column"
              slot-scope="{ row, update }"
            >
              <input
                v-model="row[column]"
                @input="update"
                value="0"
                type="number"
                min="0"
                max="350"
              />
            </div>
          </v-client-table>
        </div>
        <div class="col-sm-3 text-left card">
          <!-- <div
            class="row text-center no-gutter mr-0 card-header border border-info"
            style="
              height: 2rem;
              padding-top: 0.3rem;
              text-align: center !important;
            "
          >
            <strong>Week: 3 </strong>
            <strong class="ml-3"> Available Vaccines</strong>
          </div> -->
          <div class="row no-gutter pr-5 mt-2">
            <div class="col-6">Request for Week of:</div>
            <span >{{DisplayWeek3}}</span>
            <div class="col-6">
              <span class="" type="text" v-show="false">
                <datepicker
                  :disabled="disdates"
                  :open-date="new Date()"
                  :disabledDates="{
                    days: [0, 1, 3, 4, 5, 6],
                    to: new Date(Date.now() - 8640000),
                  }"
                  v-model="Week3"
                  :format="dateFormat"
                  id="ReqDate3"
                  :bootstrap-styling="true"
                  :input-class="datapickClass"
                  name="ReqDate3"
                ></datepicker>
              </span>
            </div>
            
          </div>
          <v-client-table class="mb-0"
            :columns="columns"
            v-model="Week3Products"
            :options="options"
          >
            <div
              v-for="column in options.editableColumns"
              :key="column"
              :slot="column"
              slot-scope="{ row, update }"
            >
              <input
                type="number"
                min="0"
                max="350"
                v-model="row[column]"
                @input="update"
              />
            </div>
          </v-client-table>
        </div>
        <div class="col-sm-3 text-left card">
          <!-- <div
            class="row text-center no-gutter mr-0 card-header border border-info"
            style="
              height: 2rem;
              padding-top: 0.3rem;
              text-align: center !important;
            "
          >
            <strong>Week: 4 </strong>
            <strong class="ml-3"> Available Vaccines</strong>
          </div> -->
          <div class="row no-gutter pr-5 mt-2">
            <div class="col-6">Request for Week of:</div>
            <div class="col-6">
              <span >{{DisplayWeek4}}</span>
              <span class="" type="text" v-show="false">
                <datepicker
                  :disabled="disdates"
                  :open-date="new Date()"
                  :disabledDates="{
                    days: [0, 1, 3, 4, 5, 6],
                    to: new Date(Date.now() - 8640000),
                  }"
                  v-model="Week4"
                  :format="dateFormat"
                  id="ReqDate4"
                  :bootstrap-styling="true"
                  :input-class="datapickClass"
                  name="ReqDate4"
                ></datepicker>
              </span>
            </div>
            <div></div>
          </div>
          <v-client-table class="mb-0"
            :columns="columns"
            v-model="Week4Products"
            :options="options"
          >
            <div
              v-for="column in options.editableColumns"
              :key="column"
              :slot="column"
              slot-scope="{ row, update }"
            >
              <input
                type="number"
                min="0"
                max="350"
                v-model="row[column]"
                @input="update"
              />
            </div>
          </v-client-table>
        </div>
      </div>
    </div>

    <form>
      <div class="form-group ml-4 no-gutters">
        <label for="com" class=""><strong>Comments :</strong></label>
        <textarea
          class="form-control"
          id="com"
          rows="2"
          v-model="Comments"
          maxlength="256"
        ></textarea>
      </div>
    </form>
    <div class="row ml-2">
      <div class="col-4">
        <button
          v-on:click="SubmitChanges"
          type="button"
          class="btn btn-primary btn-sml mt-1"
        >
          Submit Request
        </button>
      </div>
      <div class="col-4">
        <button
          v-on:click="Exit"
          type="button"
          class="btn btn-primary btn-sml mt-1"
        >
          Exit Request
        </button>
      </div>
      <div class="col-4"></div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import axios from "axios";

export default {
  props: { ClinicNo: "" },
  data: function () {
    return {
      valQty :350,
      prod1qty:[{id:'0',text :'0'},{id:'30',text :'30'},{id:'60',text :'60'},{id:'90',text :'90'},{id:'100',text :'100'}],
      prod2qty:[{id:'0',text :'0'},{id:'140',text :'140'},{id:'280',text :'280'},{id:'200',text :'200'}],
      prod3qty:[{id:'0',text :'0'},{id:'30',text :'30'},{id:'60',text :'60'},{id:'90',text :'90'},{id:'100',text :'100'}],
      prod4qty:[{id:'0',text :'0'},{id:'30',text :'30'},{id:'60',text :'60'},{id:'90',text :'90'},{id:'100',text :'100'}],
      prod5qty:[{id:'0',text :'0'},{id:'30',text :'30'},{id:'60',text :'60'},{id:'90',text :'90'},{id:'100',text :'100'}],
      week1qty:[{id:'0',text :'0'},{id:'30',text :'30'},{id:'60',text :'60'},{id:'90',text :'90'},{id:'100',text :'100'}],
      validdata: true,
      clinic: [],
      disdates: true,
      disWeek1: false,
      disWeek2: false,
      disWeek3: false,
      disWeek4: false,
      Week1: "",
      Week2: "",
      Week3: "",
      Week4: "",
      DisplayWeek1: "",
      DisplayWeek2: "",
      DisplayWeek3: "",
      DisplayWeek4: "",
      Comments: "",
      //ClinicNo: "",
      CutoffDate: new Date(),
      dateFormat: "",
      datapickClass: "form-control form-control-xs my-0",
      HSN: "",
      tuesdays: [],
      columns: ["name", "qty"],
      Week1Products: [],
      Week2Products: [],
      Week3Products: [],
      Week4Products: [],
      options: {
        texts: {
          count: "",
          first: "First",
          last: "Last",
          limit: "Records:",
          page: "Page:",
          noResults: "No Vaccines Available",
          loading: "Loading...",
          defaultOption: "Select {column}",
          columns: "Columns",
        },
        sortIcon: {
          base: "fas",
          is: "fa-sort",
          up: "fa-sort-up",
          down: "fa-sort-down",
        },
        perPage: 10,
        filterable: false,
        headings: {
          name: "Vaccine",
          qty: "Dosage Quantity",
        },
        editableColumns: ["qty"],
        sortable: ["name"],
        //  filterable: ["name"],
        filterable: "",
      },
    };
  },
  filters: {
    moment: function (date) {
      return moment(date, "YYYY-MM-DD").format("YYYY/MM/DD");
    },
    stringify(value) {
      return JSON.stringify(value, null, 2);
    },
  },

  components: {
    Datepicker,
  },
  computed: {
    UserName() {
      return !this.$store.getters.GetCurrentUser
        ? false
        : this.$store.getters.GetCurrentUser;
    },
  },
  created: function () {
    this.dateFormat = this.$store.getters.GetDateFormat;
    this.GetFiveTuesdays();
   // this.GetProductQty();
  },
  methods: {
    showMsg(msg, data, Title) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxOk(msg, {
          title: Title,
          size: "md",
          buttonSize: "md",
          okVariant: "danger",
          okTitle: "Close",
          footerClass: "p-2",
          hideHeaderClose: true,
          hideHeaderCancel: true,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
          if (value) {
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    isNumeric(num) {
      return !isNaN(num);
    },
    ValidateData() {
      var msg = "";
      var vm = this;
      var totalQty = 0;
      _.forEach(this.Week1Products, function (value, key) {
        if (value.qty === "") {
          msg =
            value.name +
            " qty " +
            value.qty +
            " is invalid, Please Enter zero if Vaccine is not required.";
          vm.validdata = false;
        } else if (parseInt(value.qty) > vm.valQty) {
          msg =
            value.name +
            " qty " +
            value.qty +
            " is invalid, Please make sure total max is 350 per week.";
          vm.validdata = false;
        } else if (parseInt(value.qty) > 0) {
          totalQty = parseInt(totalQty) + parseInt(value.qty);
        }
      });
      if (msg != "") {
        vm.validdata = false;
        this.showMsg(msg, "", "Error on week 1 quantity");
      } else if (totalQty > vm.valQty) {
        vm.validdata = false;
        this.showMsg(
          "Total quantities can't exceed 350 per week.",
          "",
          " Error on week 1 quantity"
        );
      } else {
        msg = "";
        totalQty = 0;
        vm.validdata = true;
      }
      if (vm.validdata) {
        _.forEach(this.Week2Products, function (value, key) {
          if (value.qty === "") {
            msg =
              value.name +
              " qty " +
              value.qty +
              " is invalid, Please Enter zero if Vaccine is not required.";
            vm.validdata = false;
          } else if (parseInt(value.qty) > vm.valQty) {
            msg =
              value.name +
              " qty " +
              value.qty +
              " is invalid, Please make sure total max is 350 per week.";
            vm.validdata = false;
          } else if (parseInt(value.qty) > 0) {
            totalQty = parseInt(totalQty) + parseInt(value.qty);
          }
        });
        //console.log(vm.validdata);
        //console.log(totalQty);
        if (msg != "") {
          vm.validdata = false;
          this.showMsg(msg, "", " Error on week 2 quantity");
        } else if (totalQty > vm.valQty) {
          vm.validdata = false;
          this.showMsg(
            "Total quantities can't exceed 350 per week.",
            "",
            "Error on week 2 quantity"
          );
        } else {
          vm.validdata = true;
          msg = "";
          totalQty = 0;
        }
      }
      if (vm.validdata) {
        _.forEach(this.Week3Products, function (value, key) {
          if (value.qty === "") {
            msg =
              value.name +
              " qty " +
              value.qty +
              " is invalid, Please Enter zero if Vaccine is not required.";
            vm.validdata = false;
          } else if (parseInt(value.qty) > vm.valQty) {
            msg =
              value.name +
              " qty " +
              value.qty +
              " is invalid, Please make sure total max is 350 per week.";
            vm.validdata = false;
          } else if (parseInt(value.qty) > 0) {
            totalQty = parseInt(totalQty) + parseInt(value.qty);
          }
        });
        //console.log(vm.validdata);
        //console.log(totalQty);
        if (msg != "") {
          vm.validdata = false;
          this.showMsg(msg, "", "Error on week 3 quantity");
        } else if (totalQty > vm.valQty) {
          vm.validdata = false;
          this.showMsg(
            "Total quantities can't exceed 350 per week.",
            "",
            " Error on week 3 quantity"
          );
        } else {
          vm.validdata = true;
          msg = "";
          totalQty = 0;
        }
      }
      if (vm.validdata) {
        _.forEach(this.Week4Products, function (value, key) {
          if (value.qty === "") {
            msg =
              value.name +
              " qty " +
              value.qty +
              " is invalid, Please Enter zero if Vaccine is not required.";
            vm.validdata = false;
          } else if (parseInt(value.qty) > vm.valQty) {
            msg =
              value.name +
              " qty " +
              value.qty +
              " is invalid, Please make sure total max is 350 per week.";
            vm.validdata = false;
          } else if (parseInt(value.qty) > 0) {
            totalQty = parseInt(totalQty) + parseInt(value.qty);
          }
        });
        //console.log(vm.validdata);
        //console.log(totalQty);
        if (msg != "") {
          vm.validdata = false;
          this.showMsg(msg, "", "Error on week 4 quantity");
        } else if (totalQty > vm.valQty) {
          vm.validdata = false;
          this.showMsg(
            "Total quantities can't exceed 350 per week.",
            "",
            " Error on week 4 quantity"
          );
        } else {
          vm.validdata = true;
          msg = "";
          totalQty = 0;
        }
      }
    },
    Exit: function (event) {
      // this.$root.$emit("bv::hide::modal", "phModal", "#btnShow");
      this.$emit("finished");
    },
    GetAvaiProducts(weekNo) {
      var vm = this;
      var weekdate;
      if (weekNo == 1) {
        vm.Week1Products = [];
        weekdate = moment(vm.Week1, "YYYY-MM-DD").format("LL");
      } else if (weekNo == 2) {
        vm.Week2Products = [];
        weekdate = moment(vm.Week2, "YYYY-MM-DD").format("LL");
      } else if (weekNo == 3) {
        vm.Week3Products = [];
        weekdate = moment(vm.Week3, "YYYY-MM-DD").format("LL");
      } else if (weekNo == 4) {
        vm.Week4Products = [];
        weekdate = moment(vm.Week4, "YYYY-MM-DD").format("LL");
      }
      ////console.log(weekdate)
      var params = new URLSearchParams();
      params.append("weekof", weekdate);
      params.append("pharmacyNo", vm.ClinicNo);
      axios
        .get("SaskHealthApi/Codes/GetProductsAvailable", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response) {
          // //console.log(response.data);
          if (weekNo == 1) {
            vm.Week1Products = response.data;
          } else if (weekNo == 2) {
            vm.Week2Products = response.data;
          } else if (weekNo == 3) {
            vm.Week3Products = response.data;
          } else if (weekNo == 4) {
            vm.Week4Products = response.data;
          }
        })
        .catch(function (er) {
          if (er.status == 400) {

            
          } else if (er.status == 500) {
          }
        });
    },
    // GetProductQty() {
    //   var vm = this;
    //   axios
    //     .get("SaskHealthApi/Codes/GetProductQty", {
    //       headers: { Authorization: "Bearer " + localStorage.access_token },
    //     })
    //     .then(function (response) {
    //       // //console.log("Next Five Tuesday" +  response.data);
    //        //console.log(response.data)
    //      //vm.week1qty  = response.data[0].qty;
    //       //console.log(vm.week1qty)
    //     })
    //     .catch(function (er) {
    //       if (er.status == 400) {
    //       } else if (er.status == 500) {
    //       }
    //     })
    //     .then(function (f) {
 
    //     });
    // },
    GetFiveTuesdays() {
      var vm = this;
      axios
        .get("SaskHealthApi/Codes/GetFiveTuesdays", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
        })
        .then(function (response) {
          // //console.log("Next Five Tuesday" +  response.data);
          vm.tuesdays = response.data;
        })
        .catch(function (er) {
          if (er.status == 400) {
          } else if (er.status == 500) {
          }
        })
        .then(function (f) {
          vm.Week1 = vm.tuesdays[0];
          //vm.DisplayWeek1 = vm.tuesdays[0]
          vm.disWeek1 = true;
          // //console.log("week1 : " + vm.Week1);
          vm.Week2 = vm.tuesdays[1];
          //vm.DisplayWeek2 = vm.tuesdays[1];
          vm.Week3 = vm.tuesdays[2];
          //vm.DisplayWeek3 = vm.tuesdays[2];
          vm.Week4 = vm.tuesdays[3]; 
          //moment('2016-05-14T08:33:14-03:00', 'YYYY-MM-DDTHH:mm:ss').format()
          //vm.DisplayWeek4 = vm.tuesdays[3];
          //vm.DisplayWeek4 = moment(vm.DisplayWeek4,'YYYY-MM-DDTHH:mm:ss');
          vm.DisplayWeek1 = moment(vm.tuesdays[0]).subtract(1, "days").format("dddd, MMMM DD, YYYY");
          vm.DisplayWeek2 = moment(vm.tuesdays[1]).subtract(1, "days").format("dddd, MMMM DD, YYYY");
          vm.DisplayWeek3 = moment(vm.tuesdays[2]).subtract(1, "days").format("dddd, MMMM DD, YYYY");
          vm.DisplayWeek4 = moment(vm.tuesdays[3]).subtract(1, "days").format("dddd, MMMM DD, YYYY");
          ////console.log("dis = "+ vm.DisplayWeek4)
          vm.GetAvaiProducts(1);
          vm.GetAvaiProducts(2);
          vm.GetAvaiProducts(3);
          vm.GetAvaiProducts(4);
        });
    },
    getNextDayOfWeek(date, dayOfWeek) {
      // Code to check that date and dayOfWeek are valid left as an exercise ;)

      var resultDate = new Date(date.getTime());

      resultDate.setDate(
        date.getDate() + ((7 + dayOfWeek - date.getDay()) % 7)
      );

      return resultDate;
    },
    nextweek() {
      var today = new Date();
      var nextweek = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + 7
      );
      return nextweek;
    },
    getCurrentTuesday() {
      var d = new Date();
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -6 : 2); // adjust when day is sunday
      return new Date(d.setDate(diff));
    },
    getTuesday(d) {
      d = new Date(d);
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -6 : 2); // adjust when day is sunday
      return new Date(d.setDate(diff));
    },

    GetClinicInfo() {
      var vm = this;
      var params = new URLSearchParams();
      params.append("username", vm.UserName);
      axios
        .get("SaskHealthApi/Codes/GetClinicinfo", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response) {
          ////console.log(response.data);
          vm.clinic = response.data;
          vm.ClinicNo = clinic[0].clinicno;
          //console.log(vm.ClinicNo);
        })
        .catch(function (er) {
          if (er.status == 400) {
          } else if (er.status == 500) {
          }
        });
    },

    IsCutoffdateExist(cDate) {
      var vm = this;
      var params = new URLSearchParams();
      params.append("cuttoffdate", cDate);
      params.append("pharmacyNo", vm.ClinicNo);
      axios
        .get("SaskHealthApi/Codes/IsPharmacyCutoffExist", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response) {
          ////console.log(response.data);
        })
        .catch(function (er) {
          if (er.status == 400) {
          } else if (er.status == 500) {
          }
        });
    },
    SubmitChanges() {
      this.ValidateData();
      //this.validdata = false;
      //console.log("this.validdata = " + this.validdata);
      if (this.validdata) {
        var vm = this;
        var url = "SaskHealthApi/Codes/PostPharmacyRequest/";
        var params = {
          _: Date.now(),
          CutoffDate: vm.Week1,
          Comments: vm.Comments,
          ClinicNo: vm.ClinicNo,
          Week1: vm.Week1,
          Week2: vm.Week2,
          Week3: vm.Week3,
          Week4: vm.Week4,
          Week1Products: vm.Week1Products,
          Week2Products: vm.Week2Products,
          Week3Products: vm.Week3Products,
          Week4Products: vm.Week4Products,
        };
        axios({
          method: "post",
          url: url,
          headers: {
            Authorization: "Bearer " + vm.$store.getters.GetAccessToken,
          },
          data: params,
        })
          .then(function (response) {
            //console.log(response.data);
            vm.showMsg(response.data, "", "Request Confirmation");
          })
          .catch(function (er) {
            if (er.status == 500) {
              vm.showMsg(
                "Error while processing your request, please contact system admin.",
                "",
                "Request Confirmation"
              );
            } else if (er.status == 400) {
              vm.showMsg(
                "Error while processing your request, please contact system admin.",
                "",
                "Request Confirmation"
              );
            }
          })
          .then(function () {});
      }
    },

    update(row) {
      //console.log(qty);
    },
    submitForm() {
      ////console.log(this.data1);
      // //console.log(this.data2);
      ////console.log(this.data3);
      // //console.log(this.data4);
    },
  },
};
</script>